/** `auth` namespace — Swedish (source of truth). */
const auth = {
  login: {
    brand: 'HUB AI',
    title: 'Logga in',
    emailHint: 'Ange e-postadress för att få en engångskod.',
    otpHint: 'Ange 6-siffrig kod som skickades till {{email}}.',
    inviteHint: 'Du har blivit inbjuden till {{project}}. Logga in för att gå med.',
    emailLabel: 'E-post',
    emailPlaceholder: 'namn@företag.se',
    continue: 'FORTSÄTT',
    sending: 'SKICKAR...',
    or: 'ELLER',
    continueWithGoogle: 'Fortsätt med Google',
    continueWithMicrosoft: 'Fortsätt med Microsoft',
    verify: 'Verifiera kod',
    verifying: 'Verifierar...',
    changeEmail: 'Byt e-post',
    resendIn: 'Skicka igen om {{seconds}}s',
    resending: 'Skickar...',
    resend: 'Skicka ny kod',
    devCode: 'Utvecklingsläge – kod: {{code}}',
  },
  notice: {
    codeSent: 'Vi har skickat en kod till din e-post.',
    codeResent: 'Ny kod skickad.',
    inviteInvalid: 'Inbjudan har gått ut eller är ogiltig.',
    staleSession: 'Din session har gått ut. Logga in igen.',
  },
  requestError: {
    domainNotAllowed:
      'Den här e-postdomänen har inte åtkomst. Kontakta en administratör för att bli inbjuden.',
    deliveryFailed: 'Kunde inte leverera e-postkod just nu. Försök igen snart.',
    generic: 'Kunde inte skicka kod. Försök igen.',
  },
  otpError: {
    invalid: 'Koden är felaktig. Kontrollera och försök igen.',
    expired: 'Koden har gått ut. Skicka en ny kod.',
    alreadyUsed: 'Koden är redan använd. Skicka en ny kod.',
    attemptsExceeded: 'För många felaktiga försök. Begär en ny kod.',
    invalidChallenge: 'Inloggningssessionen blev ogiltig. Börja om med e-post.',
    staleSession: 'Sessionen gick ut. Logga in igen.',
    missingChallenge: 'Utmaningen saknas. Börja om med e-post.',
    generic: 'Ogiltig kod eller session. Försök igen.',
  },
  resendError: {
    throttled: 'Vänta tills nedräkningen är klar innan du skickar igen.',
    expired: 'Koden har gått ut. Begär en ny inloggning från e-poststeget.',
    alreadyUsed: 'Koden är redan använd. Börja om med e-post.',
    attemptsExceeded: 'För många försök. Börja om med e-post.',
    invalidChallenge: 'Inloggningssessionen blev ogiltig. Börja om med e-post.',
    generic: 'Kunde inte skicka ny kod ännu.',
  },
  oauthError: {
    domainNotAllowed:
      'Den här e-postdomänen har inte åtkomst. Kontakta en administratör för att bli inbjuden.',
    tokenExchangeFailed: 'Inloggningen misslyckades. Försök igen.',
    invalidState: 'Inloggningssessionen gick ut. Försök igen.',
    missingParams: 'Inloggningen misslyckades. Försök igen.',
    noEmail: 'Ingen e-postadress mottogs från leverantören.',
    accessDenied: 'Inloggningen avbröts.',
    generic: 'Inloggningen misslyckades. Försök igen.',
  },
  brand: {
    taglineLead: 'Er ',
    taglineHighlight: 'Digitala Medarbetare',
    taglineMiddle: 'som gör jobben i ',
    taglineEmphasis: 'mellanrummen',
    taglineEnd: '.',
    secureLogin: 'Säker inloggning',
  },
}

export default auth
